import React from "react";
import { NavLink, useLocation } from "react-router-dom";

const links = [
  {
    name: "Download Strategies",
    path: "/strategies",
  },
  {
    name: "All Machine",
    path: "/",
  },
  // {
  //   name: "Active Machines",
  //   path: "/Active",
  // }
  // ,
  {
    name: "Accepted Documents",
    path: "/signedDoc",
  }
 
];

const NavLinks: React.FC<{ classActive: string }> = ({ classActive }) => {
  const route = useLocation();
  const currentPath = route.pathname;
  return (
    <>
      <nav>
        <ul className="grid gap-2">
          {links.map((link) => (
            <li key={link.path}>
              <NavLink
                to={link.path}
                className={`px-4 py-2 w-full block transition     ${
                  currentPath === link.path
                    ? classActive
                    // : "text-[#50CAFF] bg-[#373941]  border-r-4 border-[#6A6C75]"
                    :""
                }`}
              >
                {link.name}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      
    </>
  );
};

export default NavLinks;
